import Table from '@utils/table'
import TableSelect from '@utils/table-select'
import Operation from '@utils/common/operation'
import Search from '@utils/search'

const search = new Search('ordersupplier.externalcontrol')
  .placeholder('dilogPlaceholder')
  .setSpan(12)
  .add('purchaseNo')

function remove(this: any, row: any, index: number) {
  const value = [...this.value]
  value.splice(index, 1)
  this.$emit('input', value)
}

const operation = new Operation()
  .add('release').label('common.remove').handle(remove)

const dialogTable = new Table('ordersupplier.externalcontrol')
  .sortable(false)
  .add('purchaseNo')
  .add('purchaseSeq')
  .add('purchasePhaseSeq')
  .add('goodsNo')
  .add('goodsName')
  .add('spec')
  .add('applyQty').label('orderQty')
  .add('checkedQty')
  .add('checkedOkQty')

function getApplyQty(data: any) {
  return {
    component: 'el-input-number',
    min: 0,
    max: data.row.maxApplyQty,
    controlsPosition: 'right'
  }
}

function validApplyQty(this: any, rules: any, value: number, callback: any) {
  if (value > 0) {
    return callback()
  }
  callback(new Error(this.$t('ordersupplier.externalcontrol.requirdApplyQty')))
}

const table = new Table('ordersupplier.externalcontrol')
  .type('index')
  .sortable(false)
  .edit(true)
  .add('seq')
  .add('purchaseNo')
  .add('purchaseSeq')
  .add('purchasePhaseSeq')
  .add('goodsNo')
  .add('goodsName')
  .add('spec')
  .add('applyQty').editor(getApplyQty).width(160).rules([{ validator: validApplyQty, trigger: 'blur' }])
  .add('maxApplyQty')
  .lib('remarks').editor()

function filter(selection: any[]) {
  return selection.map(item => {
    const applyQty = item.applyQty - item.checkedQty
    return { ...item, maxApplyQty: applyQty, applyQty: applyQty }
  })
}
const tableSelect = new TableSelect('ordersupplier.externalcontrol')
  .type('page')
  .search(search)
  .url('/srmCheckApply/getPurchasePage', process.env.VUE_APP_PURCHASE_API)
  .title('entry')
  .dialogTitle('addEntry')
  .table(table)
  .operation(operation)
  .dialogTable(dialogTable)
  .filter(filter)

export default tableSelect
